'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';

import {
  AdditionalSettingsArticleList,
  BlockProps,
  ComponentBaseProps,
} from '@sola/schema/lib/schema.js';

import { ArticleControls } from '../../../molecules/article-group/article-controls';
import {
  ArticleTabs,
  ArticleTabsSkeleton,
} from '../../../molecules/article-group/article-tabs';

const queryClient = new QueryClient();

export type ArticleListCoreProps = BlockProps &
  ComponentBaseProps & {
    hasTabs?: boolean;
  };

export const ArticleListCore: React.FC<ArticleListCoreProps> = ({
  seoLevel = 2,
  settings,
  hasTabs = true,
}) => {
  const articleListSettings = settings
    ? AdditionalSettingsArticleList.parse(settings)
    : undefined;

  return (
    <section className="ArticleListCore component component--no-header">
      <div className="ArticleListCore__container container">
        {hasTabs ? (
          <Suspense fallback={<ArticleTabsSkeleton />}>
            <QueryClientProvider client={queryClient}>
              <ArticleTabs
                seoLevel={seoLevel}
                articleType={articleListSettings?.articleType}
                topic={articleListSettings?.topic}
                country={articleListSettings?.country}
                theme={articleListSettings?.theme}
                limit={articleListSettings?.limit || 12}
              />
            </QueryClientProvider>
          </Suspense>
        ) : (
          <ArticleControls
            seoLevel={seoLevel}
            articleType={articleListSettings?.articleType}
            topic={articleListSettings?.topic}
            country={articleListSettings?.country}
            theme={articleListSettings?.theme}
            limit={articleListSettings?.limit || 12}
          />
        )}
      </div>
    </section>
  );
};
